"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * For tests to work property, all coverages registered to mock quotation instances must have their
 * coverageId mapped in one of these entries via the `code` property.
 */
var mockCoverageCatalogResumeList = [
    { code: '001', type: 'C', applyDeductible: false },
    { code: '002', type: 'C', applyDeductible: false },
    { code: '003', type: 'C', applyDeductible: false },
    { code: '004', type: 'C', applyDeductible: true },
    { code: '005', type: 'C', applyDeductible: true },
    { code: '006', type: 'E', applyDeductible: false },
    { code: '007', type: 'E', applyDeductible: false },
    { code: '008', type: 'E', applyDeductible: false },
];
exports.default = mockCoverageCatalogResumeList;
//# sourceMappingURL=mockCoverageCatalogResumeList.js.map